export const statesSnop = { pendiente: 0, finalizado: 1, dudas: 2, retornado: 3 }